import { EventQueryParams } from 'src/api/event';
import { action } from 'src/store/actions';

/* Events */
export const FETCH_EVENTS = 'FETCH_EVENTS';
export const REQUEST_EVENTS = 'REQUEST_EVENTS';
export const SUCCESS_EVENTS = 'SUCCESS_EVENTS';
export const FAILURE_EVENTS = 'FAILURE_EVENTS';

export const fetchEvents = (pageable?: EventQueryParams) => action(FETCH_EVENTS, { pageable });
export const requestEvents = () => action(REQUEST_EVENTS);
export const requestEventsSuccess = (response: any) => action(SUCCESS_EVENTS, { response });
export const requestEventsFailure = (error: any) => action(FAILURE_EVENTS, { error });
